import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const dbExplorerWeb: PluginWebManifest = {
  routes: [
    {
      path: '/admin/database',
      componentPath: '@reflex/plugin-db-explorer/web/DatabasePage',
    },
  ],
};
